import { render } from "./orthopedic_assessment.vue?vue&type=template&id=d20d77ce&scoped=true"
import script from "./orthopedic_assessment.vue?vue&type=script&lang=js"
export * from "./orthopedic_assessment.vue?vue&type=script&lang=js"

import "./orthopedic_assessment.vue?vue&type=style&index=0&id=d20d77ce&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20d77ce"]])

export default __exports__